// extracted by mini-css-extract-plugin
export default {"NotFoundPage":"NotFoundPage_NotFoundPage__-ht4r","error_code":"NotFoundPage_error_code__ZtKJA","error_name":"NotFoundPage_error_name__lDy7n"};